type Row = Record<string, unknown>

function toCSV(rows: Row[], headers: string[]): string {
  const escape = (v: unknown): string => {
    const s = v == null ? "" : String(v)
    return s.includes(",") || s.includes('"') || s.includes("\n")
      ? `"${s.replace(/"/g, '""')}"`
      : s
  }
  const lines = [headers.map(escape).join(",")]
  for (const row of rows) {
    lines.push(headers.map((h) => escape(row[h])).join(","))
  }
  return lines.join("\n")
}

function download(content: string, filename: string, mime: string) {
  const blob = new Blob([content], { type: mime })
  const url = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

export function exportJSON(rows: Row[], filename: string) {
  download(JSON.stringify(rows, null, 2), `${filename}.json`, "application/json")
}

export function exportCSV(rows: Row[], headers: string[], filename: string) {
  download(toCSV(rows, headers), `${filename}.csv`, "text/csv")
}
